import React, {ReactNode, FC} from 'react';

import classNames from 'classnames';

import {Price} from 'components/price/price';

import s from './baseItemPrice.scss';

export type PropsType = {
    price?: number;
    specialPrice: Maybe<number | string>;
    label?: ReactNode;
    className?: string;
};

/**
 * Render price with special price for cart item
 */
export const BaseItemPrice: FC<PropsType> = ({
    className = '',
    label = null,
    price = null,
    specialPrice = null,
}) => {
    const hasSpecialPrice =
        specialPrice !== null && parseFloat(String(specialPrice)) !== parseFloat(String(price));
    const dataTestValue = JSON.stringify({
        isTotal: String(label).toLowerCase().includes('total'),
    });

    return (
        <div
            className={classNames(s.value, className, {
                [s.labeled]: label,
            })}
        >
            {label && <span className={s.label}>{label}</span>}
            <span>
                <span
                    className={classNames(s.price, {[s.revertOld]: hasSpecialPrice})}
                    data-test-name="totalPrice"
                    data-test-value={dataTestValue}
                >
                    <Price>{price}</Price>
                </span>
                {hasSpecialPrice && (
                    <span
                        className={classNames(s.price, s.revert)}
                        data-test-name="specialPrice"
                        data-test-value={dataTestValue}
                    >
                        <Price>{specialPrice}</Price>
                    </span>
                )}
            </span>
        </div>
    );
};
